import { Controller } from "@hotwired/stimulus";

// Depot answer uploader — sends a multipart POST to /juniors/:id/depot_answers
// with the chosen file. Once the upload succeeds, we reload the Turbo Frame
// containing the lesson so the user sees the new "En attente de validation"
// status without a full page refresh.
export default class extends Controller {
  static targets = ["file", "status"];
  static values = {
    elementId:  String,
    progressId: String,
    juniorId:   String,
    userId:     String,
    existingId: String
  };

  async submit() {
    if (!this.hasFileTarget || !this.fileTarget.files?.length) return;
    const file = this.fileTarget.files[0];

    this._setStatus("Envoi en cours…");

    try {
      const formData = new FormData();
      formData.append("user_id", this.userIdValue);
      formData.append("lesson_element_id", this.elementIdValue);
      formData.append("file", file);

      const response = await fetch(`/juniors/${this.juniorIdValue}/depot_answers`, {
        method: "POST",
        headers: {
          "X-CSRF-Token": this._csrf(),
          Accept: "application/json"
        },
        credentials: "same-origin",
        body: formData
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      this._setStatus("Fichier envoyé — en attente de validation.");
      this.element.dispatchEvent(new CustomEvent("lc-training-element:progress-changed", {
        bubbles: true,
        detail: { reason: "depot-uploaded" }
      }));

      // Full page reload — same reasoning as the QCM player: the static
      // turbo-frame doesn't refresh reliably via `src = ...` and we'd
      // rather have a 100%-reliable post-upload state than a fancy partial
      // refresh that occasionally hangs.
      window.location.reload();
    } catch (_e) {
      this._setStatus("Échec de l'envoi — réessaie.", true);
    }
  }

  _setStatus(text, isError = false) {
    if (!this.hasStatusTarget) return;
    this.statusTarget.textContent = text;
    this.statusTarget.style.color = isError ? "#b91c1c" : "var(--ds-text-muted)";
  }

  _csrf() {
    return document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") || "";
  }
}
